import styles from './UrlTracking.module.scss';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { formatTimeFromSeconds } from '@/utils/timeUtils';

// The shared Table component's default header (Medium weight, hardcoded
// #343942) doesn't match DomainUsageTable's header above it (Semibold,
// gray-500) — customHeader overrides just the header render per column so
// this nested table reads as a continuation of the same table, not a
// visually distinct one.
const renderHeader = (column) => (
  <Text
    variant={textVariantsEnum.Text_13}
    fontWeight={fontWeightEnum.Semibold}
    color="gray-500"
  >
    {column.name}
  </Text>
);

export const urlActivitiesTableConfig = () => [
  {
    id: 'no',
    name: '#',
    sortable: false,
    customHeader: renderHeader,
    cellRenderer: (_row, rowIndex) => (
      <Text
        variant={textVariantsEnum.Text_13}
        fontWeight={fontWeightEnum.Medium}
        className={styles.numberCell}
      >
        {rowIndex + 1}
      </Text>
    ),
  },
  {
    id: 'url',
    name: 'URL',
    sortable: false,
    customHeader: renderHeader,
    cellRenderer: (row) => (
      <Text
        variant={textVariantsEnum.Text_13}
        fontWeight={fontWeightEnum.Medium}
        className={styles.urlCell}
        title={row.url}
      >
        {row.url}
      </Text>
    ),
  },
  {
    id: 'title',
    name: 'TITLE',
    sortable: false,
    customHeader: renderHeader,
    cellRenderer: (row) => (
      <Text
        variant={textVariantsEnum.Text_13}
        fontWeight={fontWeightEnum.Medium}
        className={styles.titleCell}
        title={row.title}
      >
        {row.title || '—'}
      </Text>
    ),
  },
  {
    id: 'timeSpent',
    name: 'TIME SPENT',
    sortable: false,
    customHeader: renderHeader,
    cellRenderer: (row) => (
      <Text
        variant={textVariantsEnum.Text_13}
        fontWeight={fontWeightEnum.Medium}
        className={styles.timeSpentCell}
      >
        {formatTimeFromSeconds(row.totalSeconds)}
      </Text>
    ),
  },
];
